import React from 'react';
import { NoticeProps } from 'react-select/src/components/Menu';

import { Option } from '../option.model';

type NoOptionsMessageProps = {
  noOptionsMessage?: React.ReactNode;
} & NoticeProps<Option, true>;

export const NoOptionsMessage = ({
  children,
  innerProps,
  noOptionsMessage,
}: NoOptionsMessageProps) => (
  <div className="px-6 py-4 text-center" {...innerProps}>
    {noOptionsMessage ?? children}
  </div>
);
